import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import { makeValidUrl, getNavTag } from './utils';

const MenuSublistSec = ({
  linkClick,
  makeAbFlagUrl,
  data: { childDetails = [], name = '', url = '', hot = false, tag } = {}
}) => {
  if (_isEmpty(childDetails) && _isEmpty(name)) {
    return null;
  }
  const { location = {} } = window;
  const { pathname } = location;

  return (
    <div className="third-level" id="third">
      {name && url && (
        <div className="title">
          <a
            href={makeAbFlagUrl(makeValidUrl(url))}
            onClick={() => {
              linkClick(url, name);
            }}
          >
            <span><strong>{name}</strong></span>
            {getNavTag({ tag, pathname, url })}
          </a>
        </div>
      )}
      {name && !url && (
        <div className="title">
          <span className="title-tag" role='heading' aria-level={2}><strong>{name}</strong></span>
          {getNavTag({ tag, pathname, url })}
        </div>
      )}
      {childDetails && (
        <div className="items" role="list">
          {childDetails.map((data, i) => {
            let { name, url, tag } = data;
            if (url) {
              return (
                <div key={i} role="listitem">
                <span>
                  <a
                    href={makeAbFlagUrl(makeValidUrl(url))}
                    aria-label={name}
                    onClick={() => {
                      linkClick(url, name);
                    }}
                  >
                    {name}
                    {getNavTag({ tag, pathname, url })}
                  </a>
                </span>
                </div>
              );
            }
            return (
              <div  role="listitem">
                <span>{name}</span>
                {getNavTag({ tag, pathname, url })}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MenuSublistSec;
